/* eslint-disable @typescript-eslint/no-explicit-any */
import IconButton from 'components/IconButton';
import { isAdminUserLoggedIn } from 'lib/helper';
import React from 'react';

import DeleteMemberModal from './DeleteMemberModal';
import InviteMemberModal from './InviteMemberModal';
import SubscriptionModal from './SubscriptionModal';

/**
 * Props for the RowActions component
 */
interface RowActionsProps {
  rowData: any;
}

const RowActions: React.FC<RowActionsProps> = ({ rowData }) => {
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] =
    React.useState(false);
  const [inviationModalOpen, setInviationModalOpen] = React.useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const userData = {
    first_name: rowData.first_name,
    last_name: rowData.last_name,
    email: rowData.email,
  };

  const toggleSubscriptionModal = () =>
    setIsSubscriptionModalOpen(!isSubscriptionModalOpen);

  return (
    <div className="d-flex justify-content-end">
      <IconButton
        id="resend-invite"
        iconClass="fa fa-paper-plane"
        size="sm"
        disabled={rowData.is_active}
        tooltip={
          rowData.is_active ? 'Member is already active' : 'Resend invite'
        }
        onClick={() => {
          setInviationModalOpen(true);
        }}
      />
      <IconButton
        id="manage-subscription"
        iconClass="fa fa-bell"
        disabled={
          !rowData.is_active ||
          (!isAdminUserLoggedIn() &&
            localStorage.getItem('loggedInUser') !== rowData.email)
        }
        size="sm"
        tooltip={
          !rowData.is_active
            ? 'Member is not active'
            : !isAdminUserLoggedIn() &&
                localStorage.getItem('loggedInUser') !== rowData.email
              ? "You are not authorized to manage this user's subscription"
              : 'Manage subscription'
        }
        onClick={toggleSubscriptionModal}
      />
      {/* TODO: Enable when admin/member functionality is properly implemeneted */}
      {/* {isAdminUserLoggedIn() && (
        <IconButton
          id="assign-admin"
          iconClass={
            rowData.company_role === 'ADMIN'
              ? 'fa fa-user-slash'
              : 'fa fa-user-shield'
          }
          disabled={rowData.email === localStorage.getItem('loggedInUser')}
          size="sm"
          tooltip={
            rowData.email === localStorage.getItem('loggedInUser')
              ? 'You cannot modify your own role.'
              : rowData.company_role === 'ADMIN'
              ? 'Revoke admin role'
              : 'Assign admin role'
          }
          onClick={() => {
            setRoleModalOpen(true);
          }}
        />
      )} */}
      {isAdminUserLoggedIn() && (
        <IconButton
          id="delete-user"
          iconClass="fa fa-trash"
          disabled={rowData.email === localStorage.getItem('loggedInUser')}
          size="sm"
          tooltip={
            rowData.email === localStorage.getItem('loggedInUser')
              ? 'You cannot remove yourself.'
              : 'Remove Member'
          }
          onClick={() => {
            setDeleteModalOpen(true);
          }}
        />
      )}
      {isSubscriptionModalOpen && (
        <SubscriptionModal
          isOpen={isSubscriptionModalOpen}
          toggle={toggleSubscriptionModal}
          userId={rowData.users_id}
          userSubscriptions={rowData.subscriptions}
        />
      )}
      {inviationModalOpen && (
        <InviteMemberModal
          toggle={() => setInviationModalOpen(!inviationModalOpen)}
          isOpen={inviationModalOpen}
          userData={userData}
        />
      )}
      {/* {roleModalOpen && (
        <ChangeRoleModal
          isOpen={roleModalOpen}
          onClose={() => setRoleModalOpen(!roleModalOpen)}
          currentRole={rowData.company_role}
          targetRole={rowData.company_role === 'ADMIN' ? 'MEMBER' : 'ADMIN'}
          memberId={rowData.users_id}
          companyId={companyId}
          onRoleChanged={onRoleChanged}
        />
      )} */}
      {deleteModalOpen && (
        <DeleteMemberModal
          isOpen={deleteModalOpen}
          toggle={() => setDeleteModalOpen(!deleteModalOpen)}
          memberId={rowData.users_id}
          memberName={rowData.full_name}
        />
      )}
    </div>
  );
};

export default RowActions;
